import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, User } from 'lucide-react';
import { motion } from 'framer-motion';
import { login } from '../lib/auth';
export function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (login(username, password)) {
      navigate('/admin/panel');
    } else {
      setError('Credenciales incorrectas. (Pista: admin / admin123)');
    }
  };
  return <div className="min-h-screen flex items-center justify-center bg-dark px-4" data-id="element-225">
      <div className="absolute top-6 left-6" data-id="element-226">
        <Link to="/" className="flex items-center gap-2 text-light hover:text-gold transition-colors" data-id="element-227">
          <span className="font-bold tracking-widest" data-id="element-228">
            BARBER<span className="text-gold" data-id="element-229">OS</span>
          </span>
        </Link>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="w-full max-w-md bg-dark-card rounded-3xl border border-white/5 p-8 shadow-2xl" data-id="element-230">
        <div className="text-center mb-8" data-id="element-231">
          <div className="w-16 h-16 bg-gold/10 text-gold rounded-full flex items-center justify-center mx-auto mb-4 border border-gold/20" data-id="element-232">
            <Lock size={32} data-id="element-233" />
          </div>
          <h1 className="text-2xl font-semibold text-light mb-2" data-id="element-234">
            Acceso Staff
          </h1>
          <p className="text-xs text-light-muted" data-id="element-235">
            Ingresá tus credenciales para gestionar la barbería.
          </p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6" data-id="element-236">
          {error && <div className="bg-red-500/10 border border-red-500/20 text-red-400 p-3 rounded-xl text-xs text-center" data-id="element-237">
              {error}
            </div>}

          <div data-id="element-238">
            <label className="block text-xs font-medium text-light-muted mb-2" data-id="element-239">
              Usuario
            </label>
            <div className="relative" data-id="element-240">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-241">
                <User size={16} className="text-light-muted" data-id="element-242" />
              </div>
              <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full pl-11 pr-4 py-3 bg-dark border border-white/10 rounded-xl text-sm text-light focus:border-gold focus:outline-none transition-colors" placeholder="admin" data-id="element-243" />
            </div>
          </div>

          <div data-id="element-244">
            <label className="block text-xs font-medium text-light-muted mb-2" data-id="element-245">
              Contraseña
            </label>
            <div className="relative" data-id="element-246">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-247">
                <Lock size={16} className="text-light-muted" data-id="element-248" />
              </div>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full pl-11 pr-4 py-3 bg-dark border border-white/10 rounded-xl text-sm text-light focus:border-gold focus:outline-none transition-colors" placeholder="••••••••" data-id="element-249" />
            </div>
          </div>

          <button type="submit" className="w-full bg-gold text-dark py-3.5 rounded-xl font-semibold hover:bg-gold-hover transition-colors" data-id="element-250">
            Ingresar al Panel
          </button>
        </form>
      </motion.div>
    </div>;
}